"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LifeOnLand = void 0;
var React = __importStar(require("react"));
var LifeOnLand = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 483.7 604"
  }, React.createElement("g", null, React.createElement("g", {
    transform: "translate(0.000000, -1.000000)"
  }, React.createElement("g", {
    transform: "translate(0.000000, 0.032043)"
  }, React.createElement("path", {
    fill: "#3EA535",
    d: "M247.3,431.9c0.9,0,1.6,0.7,1.6,1.6v52.9c0,0.9-0.7,1.6-1.6,1.6h-21.4\n        c-0.9,0-1.6-0.7-1.6-1.6v-52.9c0-0.9,0.7-1.6,1.6-1.6H247.3z"
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M482.1,510.8H129.8c-0.9,0-1.6,0.8-1.6,1.7v21.6c0,0.9,0.7,1.6,1.6,1.6h352.3\n        c0.9,0,1.6-0.7,1.6-1.6v-21.6C483.7,511.5,482.9,510.8,482.1,510.8"
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M482.1,553.6H129.8c-0.9,0-1.6,0.7-1.6,1.6v21.6c0,0.9,0.7,1.6,1.6,1.6h352.3\n        c0.9,0,1.6-0.7,1.6-1.6v-21.6C483.7,554.3,482.9,553.6,482.1,553.6"
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M415,373.4c-4.4-3.4-16.1-11.5-30.5-11.5c-10.2,0-19.8,4-28.3,12c-0.6,0.6-0.9,1.4-0.9,2.2\n        v1.9c0,0.9,0.3,1.8,1,2.4c0.8,0.6,1.6,0.8,2.5,0.6c0.2,0,0.5-0.1,0.7-0.2c0.7-0.2,1.3-0.6,1.8-1.1c1.8-1.2,6.9-2.9,14.1-2.9\n        c7.5,0,22.1,2,36.3,15.2l0.3,0.3c0.8,0.8,1.9,1.3,3.1,1.3c1.1,0,2.3-0.5,3-1.2l0.3-0.3c14.3-13.3,28.9-15.3,36.4-15.3\n        c7.3,0,12.3,1.7,14.1,2.9c0.5,0.5,1.1,0.9,1.9,1.2c0.3,0.1,1.2,0.3,2.1,0.1c1.3-0.4,2.2-1.5,2.2-2.9v-1.7c0-0.8-0.3-1.6-0.9-2.2\n        c-8.6-8.2-18.2-12.4-28.6-12.4C431.2,361.9,419.5,369.8,415,373.4"
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M393.2,232.8c-0.7,0.3-1.3,1-1.5,1.9l-0.4,1.2c-0.3,0.9-0.1,1.9,0.5,2.7\n        c0.5,0.7,1.3,1.1,2.2,1.2c0.2,0,0.3,0.1,0.4,0c0.6,0,1.2-0.2,1.7-0.4c0.3-0.1,1-0.2,2.1-0.2c1.6,0,15.8,0.5,25.2,16.5l0.1,0.2\n        c0.5,0.9,1.3,1.6,2.3,1.8c0.3,0.1,0.8,0.2,1.1,0.2c0.7,0,1.3-0.2,1.8-0.4l0.2-0.1c5.1-2.6,10.5-3.9,15.7-3.9\n        c8.9,0,14.7,3.6,16.1,5.1c0.3,0.5,0.7,1,1.2,1.3c0.3,0.2,0.8,0.4,1.1,0.6c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.2,0,0.3,0\n        c0.5,0,0.9-0.1,1.4-0.4c0.7-0.4,1.3-1,1.5-1.8l0.3-1c0.1-0.3,0.1-0.6,0.1-0.9c0-0.6-0.1-1.1-0.4-1.5\n        c-6.8-11.9-16.8-14.4-23.9-14.4c-5.3,0-9.9,1.4-12.7,2.4c-3.2-4.3-11.4-13.3-23.8-13.3C402,229.4,397.6,230.5,393.2,232.8"
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M318.7,287.1l0.1,1.6c0,1,0.6,1.8,1.4,2.4c0.7,0.4,1.6,0.6,2.4,0.4c0.2,0,0.4-0.1,0.5-0.2\n        c0.6-0.2,1.1-0.6,1.5-1.1c1.5-1.1,6.3-3.1,13.4-3.1c6.8,0,17.2,1.8,27.9,10.6l0.2,0.3c0.8,0.7,1.7,1,2.7,1h0.3\n        c1.1-0.1,2.1-0.6,2.8-1.3l0.2-0.3c11.7-12.4,24.4-14.3,30.9-14.3c4.6,0,7.9,1,9.2,1.7c0.5,0.4,1.1,0.7,1.8,1\n        c0.2,0.1,0.7,0.1,1.3,0.1c0.2,0,0.5-0.1,0.7-0.2c1.3-0.4,2.1-1.7,2-3l-0.1-1.4c-0.1-0.8-0.4-1.6-1.1-2.1\n        c-7-5.9-14.6-8.9-22.5-8.9c-12.4,0-22.3,7.3-26.4,10.9c-3.7-2.6-12.8-7.8-23.5-7.8c-9.4,0-17.8,3.9-25,11.6\n        C319,285.4,318.7,286.2,318.7,287.1"
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M140.4,315.4c0-21.1,17.1-38.2,38.2-38.2c0.8,0,1.6,0.1,2.4,0.1c2-26.7,24.3-47.8,51.5-47.8\n        c28.5,0,51.7,23.2,51.7,51.7c0,8.1-1.9,15.7-5.2,22.5c25.9,5.7,45.2,28.8,45.2,56.4c0,31.9-25.9,57.8-57.7,57.8\n        c-2.3,0-77.1-0.4-77.1-0.4c-22.6,0-40.9-18.3-40.9-40.9c0-10.9,4.3-20.7,11.1-28C148.2,341.9,140.4,329.6,140.4,315.4"
  }), React.createElement("polygon", {
    fill: "#3EA535",
    points: "0,28.1 0,53.8 0.2,53.8 17.5,35.9 17.7,35.9 17.7,148 42.3,148 42.3,1.6 22.6,1.6 \n              "
  }), React.createElement("path", {
    fill: "#3EA535",
    d: "M100.7,48C91,48,83.9,51.4,80,58.1h-0.2V21.6h42.3v-20H57.4v82.5h22.4v-3.3\n        c0-8.6,3.9-13.4,10.8-13.4c7.6,0,10.6,5.2,10.6,13.2V116c0,7.8-2.8,13.2-10.4,13.2c-8.4,0-11.4-5.6-11.4-14.3V96.5H56.9v16.6\n        c0,22.2,8.8,36.5,33.9,36.5c24.8,0,34.9-13.2,34.9-33.5V80.2C125.8,57.3,113.9,48,100.7,48"
  }), React.createElement("polygon", {
    fill: "#3EA535",
    points: "178.6,1 188.9,1 188.9,53.9 201.2,53.9 201.2,62.3 178.6,62.3"
  }), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#3EA535",
    points: "205.9,62.3 216.1,62.3 216.1,1 205.9,1"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#3EA535",
    points: "222.1,1 246.2,1 246.2,9.4 232.4,9.4 232.4,27 242.6,27 242.6,35.3 232.4,35.3 \n          232.4,62.3 222.1,62.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#3EA535",
    points: "250.7,1 275.2,1 275.2,9.4 261,9.4 261,27 271.1,27 271.1,35.3 261,35.3 261,53.9 \n          275.2,53.9 275.2,62.3 250.7,62.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#3EA535",
    d: "M199.5,133.9V101c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9\n          c0,3.7,1.6,6.3,5.2,6.3C197.8,140.2,199.5,137.6,199.5,133.9 M178.6,132.2v-29.6c0-9.6,4.7-16.5,15.5-16.5\n          c10.9,0,15.6,7,15.6,16.5v29.6c0,9.5-4.7,16.5-15.6,16.5C183.3,148.8,178.6,141.7,178.6,132.2"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#3EA535",
    points: "224.3,109.6 224.3,148 215.6,148 215.6,86.8 225.7,86.8 236.8,121.9 236.8,86.8 \n          245.4,86.8 245.4,148 236.3,148"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#3EA535",
    points: "270.1,86.8 280.4,86.8 280.4,139.6 292.7,139.6 292.7,148 270.1,148"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#3EA535",
    d: "M308.6,128.6h8.2l-4.1-24.6h-0.1L308.6,128.6z M295.8,148l11.5-61.2H319l11.6,61.2H320\n          l-1.9-11.2h-10.9l-1.8,11.2H295.8z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#3EA535",
    points: "343.5,109.6 343.5,148 334.9,148 334.9,86.8 345,86.8 356.1,121.9 356.1,86.8 \n          364.6,86.8 364.6,148 355.6,148"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#3EA535",
    d: "M385.1,139.6c4.2,0,5.9-2.5,5.9-6.2v-32.1c0-3.6-1.6-6.1-5.9-6.1h-4.3v44.4H385.1z\n            M401.3,103.2v28.4c0,9.4-3.9,16.4-14.9,16.4h-15.9V86.8h15.9C397.4,86.8,401.3,93.8,401.3,103.2z"
  }))))));
};
exports.LifeOnLand = LifeOnLand;